import { copy } from "shared/assets";
import { IAutocomplete, IFieldType, IFormFields } from "shared/types";

const { contactProperties, errors } = copy;

export const fields: IFormFields = [
  {
    name: "firstname",
    label: contactProperties.firstName.title,
    type: IFieldType.text,
    autocomplete: IAutocomplete.givenName,
  },
  {
    name: "lastname",
    label: contactProperties.lastName.title,
    type: IFieldType.text,
    autocomplete: IAutocomplete.familyName,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "company",
    label: contactProperties.company.title,
    type: IFieldType.text,
    autocomplete: IAutocomplete.organization,
  },
  {
    name: "jobTitle",
    label: contactProperties.jobTitle.title,
    type: IFieldType.text,
    autocomplete: IAutocomplete.organizationTitle,
  },
  {
    name: "email",
    label: contactProperties.email.title,
    type: IFieldType.email,
    autocomplete: IAutocomplete.email,
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 1",
      },
    },
  },
  {
    name: "phone",
    label: contactProperties.phoneNumber.title,
    type: IFieldType.phone,
  },
  {
    name: "mobile",
    label: contactProperties.mobileNumber.title,
    type: IFieldType.phone,
  },
];

export const defaultValues = {
  phone: {
    code: "BE",
  },
  mobile: {
    code: "BE",
  },
};

export const style = {
  gridTemplateColumns: "1fr 1fr",
  mobile: {
    gridTemplateColumns: "1fr",
  },
};
